import { useCallback, useState } from 'react'
import { useHistoryCustomBack } from 'weblite-router'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { StoryPeerType } from '@weblite/ts-action/story'
import { BottomDrawer } from '$common/bottom-drawer'
import { useSetNativeColors } from '$logic/native-colors'
import { openStory, uploadStory } from '$logic/story/service'
import { CreateStoryChooseFile } from './components/choose-file'
import { SubmitFile } from './components/submit-file'

export interface Props {
  isOpen?: boolean
  peerId: string
  peerType: StoryPeerType
}
export function CreateStoryModal({ isOpen = false, peerId, peerType }: Props) {
  useSetNativeColors(
    () => ({
      statusBar: '#000',
      bottomSafeArea: '#000',
    }),
    [isOpen],
    isOpen,
  )
  const [tab, setTab] = useState<'CREATE' | 'SUBMIT'>('CREATE')
  const [file, setFile] = useState<File>()

  const handleClose = useCallback(() => {
    closeCurrentModal()
  }, [])

  const onChooseFileHandler = useCallback((file: File) => {
    setFile(file)
    setTab('SUBMIT')
  }, [])

  useHistoryCustomBack(() => {
    if (tab === 'SUBMIT') {
      setTab('CREATE')
      setFile(undefined)
    } else closeCurrentModal()
  }, [tab])

  const handleSubmit = useCallback(async () => {
    if (file) {
      uploadStory(file, peerId, peerType, () => openStory({ peerId, peerType }))
      await closeCurrentModal()
    }
  }, [file, peerId, peerType])

  return (
    <BottomDrawer
      isTransparent
      isOpen={isOpen}
      isFullscreen
      onClose={closeCurrentModal}
      sx={{ height: '100%' }}
      paperProps={{
        sx: { height: '100%' },
      }}
      backdropProps={{ sx: { backdropFilter: 'blur(2px)' } }}
    >
      {file && tab === 'SUBMIT' ? (
        <SubmitFile
          file={file}
          onBack={() => setTab('CREATE')}
          handleSubmit={handleSubmit}
        />
      ) : (
        <CreateStoryChooseFile
          onClose={handleClose}
          onChooseFile={onChooseFileHandler}
        />
      )}
    </BottomDrawer>
  )
}
